'use client'

import dynamic from 'next/dynamic'

const Toaster = dynamic(() => import('@/components/ui/sonner').then((mod) => mod.Toaster), {
  ssr: false,
})

export function LazyToaster() {
  return (
    <Toaster
      richColors
      closeButton
      toastOptions={{
        classNames: {
          closeButton:
            'absolute right-0 left-[98%]! top-2 p-1 rounded-full bg-black/40 hover:bg-black/70 text-white transition',
        },
      }}
    />
  )
}
